// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-widget-template .map-header{position:absolute;left:0px;right:0px;top:0px;z-index:400;backdrop-filter:blur(5px)}.map-widget-template .wd-selectable-item .map-component-container{padding:2px}", ""]);
// Exports
module.exports = exports;
